<template>
    <div>
        <a-row style='width:100%' class='contenter'>
            <a-col span="24" class='selectDates'>
                <a-col class='arrow' @click='prevClick(bgcolor)' :class='{disableType:bgcolor}'>
                    <LeftOutlined :style='{color:"#aaaaaa"}' v-show='bgcolor'/>
                    <LeftOutlined  v-show='!bgcolor'/>
               
                </a-col>
                <a-col span="3" v-for='(item,index) in dataList' :key='index' :class='{active:date == item.trueDate}' @click='confirmDate(item.trueDate)' class='hover_content'>
                    <div class='top_line' v-show='date == item.trueDate'></div>
                    <div>
                        <div>{{item.date}}</div>
                        <div>{{item.weekDay}}</div>

                    </div>
                </a-col>
                <a-col class='arrow' @click='nextClick(endcolor)' :class='{disableType:endcolor}'>
                    <RightOutlined :style='{color:"#aaaaaa"}' v-show='endcolor'/>
                    <RightOutlined  v-show='!endcolor'/>
                
                </a-col>
            </a-col>
        </a-row>
    </div>
</template>
<script>
import { useRouter } from 'vue-router'
import { ref,inject,nextTick } from 'vue'
// import { toLunar } from "@assets/js/Lunar"
import format from "@assets/js/format"
import { LeftOutlined,RightOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue'

export default {
    componentname: "selectDate",
    components: {
        LeftOutlined,
        RightOutlined
    },
    props:{
        date : {
            type : String,
            default:'2020/11/09'
        }
    },
    setup(props,{ emit }){
        let show = ref(false);

        let maxdate = ref(new Date());
        const setmaxdate = () => {
            maxdate.value =  new Date(new Date().getTime() + 86400000*30)
        }

        setmaxdate()

        let defaultd = ref(new Date(props.date))


        let dataList = ref([
            {
                weekDay : '今天',
                date : '10/13',
                trueDate : ''
            },
            {
                weekDay : '明天',
                date : '10/14',
                trueDate : ''
            },
            {
                weekDay : '周三',
                date : '10/15',
                trueDate : ''
            },
            {
                weekDay : '周四',
                date : '10/16',
                trueDate : ''
            },
            {
                weekDay : '周五',
                date : '10/17',
                trueDate : ''
            },
            {
                weekDay : '周五',
                date : '10/17',
                trueDate : ''
            },
            {
                weekDay : '周五',
                date : '10/17',
                trueDate : ''
            },
        ])



        let activeIndex = ref(0);
        const confirmDate = (date) => {
            // console.log(activeIndex.value)
            // console.log(index)
            if(props.date == date){
                return;
            }

            let time = new Date(date).getTime();

            let now = new Date().getTime();

            if((now + 86400000*30) < time){
                // Toast('暂未发售');
                return;
            }
            changeDate(format.formatDate(date));
            nextTick(()=>{
                defaultd.value = new Date(props.date);
                initDate();

            })
        }

        const confirmcalendar = (value) => {
            show.value = false;
            changeDate(format.formatDate(getMonthDay(value).trueDate));
            nextTick(()=>{
                defaultd.value = new Date(props.date);
                initDate();
            })
        }

        let bgtime = ref('');
        let endtime = ref('');

        const initDate = () => {

            let date = new Date(props.date).getTime();
            let tag = checkDateNow(date);

            bgtime.value = getMonthDay(new Date(date + (0 - tag + 1)*86400000)).trueDate;
            endtime.value = getMonthDay(new Date(date + (6 - tag + 1)*86400000)).trueDate;
    
            //初始化选项
            dataList.value.forEach( (ele,index) =>{
                ele.date = getMonthDay(new Date(date + (index - tag + 1)*86400000)).date;
                ele.trueDate = getMonthDay(new Date(date + (index - tag + 1)*86400000)).trueDate;
                ele.weekDay = changeText(getMonthDay(new Date(date + (index - tag + 1)*86400000)).weekDay);
            })
            let now = new Date();
            let nowDate = now.getFullYear() + '/' + (now.getMonth() + 1) + '/' + now.getDate();

            if(nowDate == bgtime.value){
                checkDateNow(new Date(bgtime.value).getTime())
            }else{
                checkDateNow(new Date(endtime.value).getTime())
            }

        }
        
        const changeText = (text) =>{
            if(text == '今天' || text == '明天'){
                return text;
            }

            switch(text){
                case 0 : return '周日';
                case 1 : return '周一';
                case 2 : return '周二';
                case 3 : return '周三';
                case 4 : return '周四';
                case 5 : return '周五';
                case 6 : return '周六';

            }
        }

        const getMonthDay = (date) => {
            //转换为可用文案
            let year = new Date(date).getFullYear();
            let month = new Date(date).getMonth() + 1;
            let day = new Date(date).getDate();


            if (month < 10) {
                month = "0" + month;
            }
            if (day < 10) {
                day = "0" + day;
            }


            let weekday = new Date(date).getDay();

            let datetime = new Date(date).getTime();

            let now = new Date();
            let nowDate = new Date(now.getFullYear() + '/' + (now.getMonth() + 1) + '/' + now.getDate()).getTime();

            //兼容不同时间格式相差8小时😭
            if(datetime ==  nowDate || datetime ==  nowDate + 28800000){
                weekday = '今天'
            }else if(datetime ==  nowDate + 86400000 || datetime ==  nowDate + 86400000 + 28800000 ){
                weekday = '明天'
            }

            return {
                trueDate : year + '/' + month + '/' +day,
                date : month + '月' +day + '日',
                weekDay : weekday
            }
        }
        let bgcolor = ref(false);
        let endcolor = ref(false);

        const checkDateNow = (date) =>{
            let now = new Date();
            let nowDate = new Date(now.getFullYear() + '/' + (now.getMonth() + 1) + '/' + now.getDate()).getTime();
            let day30time = nowDate +  86400000*30;

            bgcolor.value = false
            endcolor.value = false
          
            // console.log(day30time)
            // console.log(date)
            // console.log((date + 86400000*2 + 28800000 ) == day30time || (date + 86400000*2 ) == day30time)
            if((date - 86400000) < nowDate){
                //选中日期为今天
                bgcolor.value = true
                return 1;
                //兼容不同时间格式相差8小时😭
            }else if((date - 86400000 - 28800000) == nowDate || (date - 86400000 ) == nowDate){
   
                //选中日期为明天
                return 2;

            }else if((date - 86400000*2 - 28800000) == nowDate || (date - 86400000*2 ) == nowDate){
       
                return 3;

            }else if((date + 86400000*2 - 28800000) == day30time || (date + 86400000*2 ) == day30time){
        
                //判断是不是后3天。。。。
                return 5;

            }else if((date + 86400000 - 28800000) == day30time || (date + 86400000 ) == day30time){

                //判断是不是后3天。。。。
                return 6;

            }else if((date + 86400000 ) >= day30time){
 
                endcolor.value = true
                return 7;
            }
            else{
                
                return 4;
            }
        }

        const formatter = (day) => {
            let year = moment(day.date).format("YYYY")
            let month = day.date.getMonth() + 1
            let date = day.date.getDate()
            let lunarDay = toLunar(year, month, date)
            day.bottomInfo = lunarDay[6]
            return day
        }




        const changeDate = inject('changeDate')

        checkDateNow()

        initDate();

        const prevClick = (tag) => {
            if(tag) return;
            let now = new Date();
            let nowDate = new Date(now.getFullYear() + '/' + (now.getMonth() + 1) + '/' + now.getDate()).getTime()
            let bgtimestr = new Date(bgtime.value).getTime();

            if(nowDate == bgtimestr){
                message.info('您想买昨天的车票么😊')
            }else{
                let preDay = bgtimestr - 86400000
                //初始化选项
                dataList.value.forEach( (ele,index) =>{
                    ele.date = getMonthDay(new Date(preDay + (index)*86400000)).date;
                    ele.trueDate = getMonthDay(new Date(preDay + (index)*86400000)).trueDate;
                    ele.weekDay = changeText(getMonthDay(new Date(preDay + (index)*86400000)).weekDay);
                })
                bgtime.value = dataList.value[0].trueDate
                endtime.value = dataList.value[6].trueDate
                checkDateNow(new Date(dataList.value[0].trueDate).getTime())
            }
        }

        const nextClick = (tag) => {
            if(tag) return;
            let now = new Date();
            let nowDate = new Date(now.getFullYear() + '/' + (now.getMonth() + 1) + '/' + now.getDate()).getTime()
            let endtimestr = new Date(endtime.value).getTime();
            let bgtimestr = new Date(bgtime.value).getTime();
            let nextDay = bgtimestr + 86400000
            let endDay = endtimestr + 86400000
            if(endDay   >  nowDate + 86400000*30){
                message.info('暂时不会卖30天以后的车票😠')
            }else{
        
                //初始化选项
                dataList.value.forEach( (ele,index) =>{
                    ele.date = getMonthDay(new Date(nextDay + (index)*86400000)).date;
                    ele.trueDate = getMonthDay(new Date(nextDay + (index)*86400000)).trueDate;
                    ele.weekDay = changeText(getMonthDay(new Date(nextDay + (index)*86400000)).weekDay);
                })
                bgtime.value = dataList.value[0].trueDate
                endtime.value = dataList.value[6].trueDate

                checkDateNow(new Date(dataList.value[6].trueDate).getTime())
            }


        }

  
        return {
            endcolor,
            bgcolor,
            nextClick,
            prevClick,
            formatter,
            defaultd,
            show,
            confirmDate,
            activeIndex,
            dataList,
            confirmcalendar,
            maxdate

        }
    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .contenter{
        position: relative;
        overflow: hidden;
        background: #F8F8F8;

        border: 1px solid #CDCCCD;

    }
    .selectDates{
        display: flex;
        justify-content: space-around;
        position: relative;
        // right:200px;
        &>div{
            font-size:14px;
            position: relative;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            padding: 10px 0;
            cursor: pointer;
            .top_line{
                position: absolute;
                height: 7px;
                background: #0D6DBF;
                width: 100%;
                top:0;
                border-radius: 0;
            }
            &>div{
                border-radius: 4px;
            }
            div{
                text-align: center;
                color:#000;
            }
        }

    }
    .calendar_cont{
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .hover_content:hover{
        div{
            color:#fff;
        }

        background: #0D6DBF;
    }
    .active{
        background: #fff!important;
        div{
            color:#000!important;
        }


    }
    .line{
        width: 1px;

        background: #fff;
        position: absolute;
        right: 0px;
        top:11px;
    }
    .arrow{
        width:6.25%;
        box-sizing: border-box;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    .disableType{
        cursor: not-allowed!important;
    }

</style>
